export const readFileContent = async (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = ({ target }) => {
      try {
        if (!target?.result) {
          return reject(new Error('Cannot read file content'));
        }
        resolve(target.result.toString());
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsText(file);
  });

/**
 * Note this have side effect of using DOM!
 */
export const downloadTextAsFile = (fileName: string, text: string) => {
  const element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
  );
  element.setAttribute('download', fileName);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
